import React from 'react';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { ArrowRight, MapPin, Clock, Briefcase } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const openings = [
  {
    id: 1,
    title: 'Consultant Senior - Finance',
    location: 'Zurich',
    type: 'CDI',
    description: 'Nous recherchons un consultant expérimenté pour renforcer notre équipe Finance à Zurich.'
  },
  {
    id: 2,
    title: 'Consultant - Technology',
    location: 'Genève',
    type: 'CDI',
    description: 'Rejoignez notre équipe Technology pour accompagner nos clients dans leurs recrutements IT.'
  },
  {
    id: 3,
    title: 'Business Developer',
    location: 'Lausanne',
    type: 'CDI',
    description: 'Développez notre portefeuille clients en Suisse romande.'
  },
  {
    id: 4,
    title: 'Chargé(e) de Recherche',
    location: 'Zurich',
    type: 'CDI',
    description: 'Soutenez nos consultants dans l\'identification et l\'approche de candidats qualifiés.'
  }
];

const benefits = [
  'Salaire compétitif + commissions attractives',
  'Formation continue et développement de carrière',
  'Environnement de travail moderne',
  'Télétravail flexible',
  'Événements d\'équipe réguliers',
  'Assurance maladie complémentaire'
];

const CarrieresPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero */}
      <section className="relative bg-gray-900 text-white py-24">
        <div className="absolute inset-0">
          <ResponsiveImage loading="eager"
            src="https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1600&q=80"
            alt=""
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-serif mb-6">Carrières chez Recrutement Suisse</h1>
          <p className="text-xl opacity-90 max-w-2xl">
            Rejoignez un cabinet de recrutement reconnu et participez à des projets passionnants au c\u0153ur du marché de l'emploi suisse.
          </p>
        </div>
      </section>

      {/* Benefits */}
      <section className="bg-[#E30022] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-serif mb-8 text-center">Ce que nous offrons</h2>
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center text-sm">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-lg font-bold">{index + 1}</span>
                </div>
                <p>{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Openings */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-serif text-gray-800 mb-8">Nos offres actuelles</h2>
        <div className="space-y-4">
          {openings.map((job) => (
            <div key={job.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow group">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 group-hover:text-[#E30022] transition-colors">
                    {job.title}
                  </h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-500 mt-2">
                    <span className="flex items-center gap-1">
                      <MapPin className="h-4 w-4" />
                      {job.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <Briefcase className="h-4 w-4" />
                      {job.type}
                    </span>
                  </div>
                  <p className="text-gray-600 mt-3">{job.description}</p>
                </div>
                <button className="flex-shrink-0 bg-[#E30022] text-white px-6 py-3 rounded hover:bg-[#c7001d] transition-colors font-medium flex items-center gap-2 group/btn">
                  Postuler
                  <ArrowRight className="h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Spontaneous Application */}
      <section className="bg-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-serif text-gray-800 mb-4">Candidature spontanée</h2>
          <p className="text-gray-600 mb-8">
            Vous ne trouvez pas le poste idéal ? Envoyez-nous votre candidature spontanée et nous vous contacterons dès qu'une opportunité correspondant à votre profil se présentera.
          </p>
          <a 
            href="/deposer-cv"
            className="inline-flex items-center gap-2 bg-[#E30022] text-white px-8 py-4 rounded hover:bg-[#c7001d] transition-colors font-medium group"
          >
            Envoyer ma candidature
            <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CarrieresPage;
